import './App.css';
import React, { useState, useEffect } from 'react';
import { useMediaQuery } from 'react-responsive';
import { useSwipeable } from 'react-swipeable'




function Contacts ({ text, links, isCurrent }) {

  const isMobile = useMediaQuery({ query: `(max-width: 1132px)` });

  return (
    <div className='page contacts' isCurrent={isCurrent} style={{display: isCurrent ? 'flex' : 'none', opacity: isCurrent ? '1' : '0'}}>
      <div className='contacts-column'>{text}</div>
      <div className='contacts-column'>{links}</div>
    </div>
  );
}


export default Contacts